import BaseControlTypeConst from "./BaseControlTypeConst"

export default class LookUpEditorTypeConst extends BaseControlTypeConst {
  
    static LAYOUT_DETAIL ='layouttemp-lookupeditor-detail'
    static DIALOGWIDTH = 'dialogWidth'
    static CMD = 'command'

  }
  